import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { createFuelTank, editFuelTank } from 'features/fuelManagement/fuelManagementSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import { ITanksModal, ITanksSensorListSingleResponse } from 'types/fuelManagement.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const TanksModal = ({ closeModal, value }: { closeModal: any, value?: ITanksModal }) => {
    const initialState: ITanksModal = {
        name: '',
        capacity: null,
        sensor: null,
        machineClass: 'STATIC',
        routeMeta: '',
        coverNote: '',
        machine: null,
        ...value,
    }
    const normalizedMachineClass =
        value?.machineClass === 'BOWSER' || (value?.machineClass as any) === 2 ? 'BOWSER' : 'STATIC'
    const [state, setState] = useState<ITanksModal>({
        ...initialState,
        machineClass: normalizedMachineClass,
        machine:
            value?.machine ??
            (value?.machineLeagueId
                ? { value: value.machineLeagueId, label: `Machine #${value.machineLeagueId}` }
                : value?.machineId
                  ? { value: value.machineId, label: `Machine #${value.machineId}` }
                  : null),
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        try {
            const resp = await dispatch(value?.id ? editFuelTank(state) : createFuelTank(state))
            if (resp.meta.requestStatus === 'fulfilled') {
                closeModal()
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            [e.target.name]: e.target.type === 'number' ? Number(e.target.value) : e.target.value
        })
    }

    const parseVehicles = (data: ITanksSensorListSingleResponse[]) => {
        return data
            ? data.map((item) => {
                const type = item.provider == 2 ? 'almaksVehicle' : item.provider == 3 ? 'develonVehicle' : 'frotcomVehicle'
                let label = item[type][item.provider == 2 ? 'name' : item.provider == 3 ? 'equipmentId' : 'model']
                if (item.provider == 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //  @ts-ignore
                    label = item[type].manufacturer + ' ' + (item[type].model || ' ') + ' ' + item[type].licensePlate
                }
                return {
                    label,
                    value: String(item[type].id) + '_' + String(item.provider)
                }
            })
            : []
    }

    const parseMachines = (data: any) => {
        return data.data.map((m) => ({ value: m.id, label: m.name }))
    }

    const isBowser = state.machineClass === 'BOWSER'

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Tank</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Tanker 1...' labelText='Name' name='name' value={state.name} onChange={handleChange} nomarg required invalid={!state.name} />
                <Input
                    placeholder='15000.'
                    labelText={isBowser ? 'Fuel capacity' : 'Capacity'}
                    name='capacity'
                    value={state.capacity}
                    onChange={handleChange}
                    nomarg
                    type='number'
                    required
                    invalid={!state.capacity}
                />
                <TabsContainer>
                    {(['STATIC', 'BOWSER'] as const).map((t) => (
                        <Tabs
                            type='button'
                            key={t}
                            active={state.machineClass === t}
                            onClick={() => setState({ ...state, machineClass: t })}
                        >
                            {t === 'STATIC' ? 'Static tank' : 'Bowser'}
                        </Tabs>
                    ))}
                </TabsContainer>
                {isBowser && (
                    <>
                        <Input
                            placeholder='water circuit · refuels remote pumps'
                            labelText='Route / circuit'
                            name='routeMeta'
                            value={state.routeMeta}
                            onChange={handleChange}
                            nomarg
                        />
                        <Input
                            placeholder='Water bowser 16 kL — aux diesel tank'
                            labelText='Description'
                            name='coverNote'
                            value={state.coverNote}
                            onChange={handleChange}
                            nomarg
                        />
                        <HonestSelectAsyncInput
                            link='machines'
                            placeholder='Which fleet machine is this bowser?'
                            name='machine'
                            labelText='Fleet machine (own fuel burn)'
                            onChange={(value: ISelectValue) => setState({ ...state, machine: value })}
                            parserFunction={parseMachines}
                            defaultValue={state?.machine?.label}
                        />
                    </>
                )}
                <HonestSelectAsyncInput
                    link='fuel/management/tank/sensor/list'
                    placeholder='Search vehicles'
                    name='sensor'
                    labelText='Sensor'
                    onChange={(value: ISelectValue) => setState({ ...state, sensor: value })}
                    parserFunction={parseVehicles}
                    noPagination
                    defaultValue={state?.sensor?.label}
                />
            </Flex>
            <Button
                style={{ marginTop: '16px' }}
                disabled={!state.name || !state.capacity || (isBowser && !state.machine?.value)}
                variant='primary'
                onClick={handleSave}
            >
                Save
            </Button>
        </Flex>
    </Modal>
}
